import React from 'react';
import { FaParking, FaSnowflake } from 'react-icons/fa';

export default function Facilities() {
  const facilities = [
    {
      id: 1,
      name: 'Professional Badminton Courts',
      description: '4 full-size international standard badminton courts with wooden flooring and LED lighting for optimal play.',
      //   icon: <FaBadmintonBirdie />,
      features: ['International Standard', 'LED Lighting']
    },
    {
      id: 2,
      name: 'Box Cricket Arena',
      description: 'Box cricket with good grass and pitch.',
      //   icon: <FaCricket />,
      features: ['Good Grass', 'Proper Pitch', 'Tournament Ready']
    },
    {
      id: 3,
      name: 'Modern Gym',
      description: 'Fully equipped gym with cardio machines, free weights, resistance training, and dedicated crossfit zone.',
      //   icon: <FaDumbbell />,
      features: ['Modern Equipment', 'Expert Trainers', 'Crossfit Zone']
    },
    {
      id: 4,
      name: 'Zumba Dance Area',
      description: 'Dedicated zumba dance area with proper flooring and sound system.',
      //   icon: <FaDumbbell />,
      features: ['Wooden Flooring', 'Sound System', 'Available']
    }
  ];

  const amenities = [
    { icon: <FaParking />, name: 'Ample Parking' },
    { icon: <FaSnowflake />, name: 'Air Conditioned' }
  ];

  return (
    <section id="facilities" className="section">
      <h2 className="section-title">Our Facilities</h2>
      <p className="section-subtitle">World-class sports facilities designed for your comfort and performance</p>

      <div className="facility-grid">
        {facilities.map((facility) => (
          <div key={facility.id} className="facility-card">
            <div className="facility-icon">{facility.icon}</div>
            <h3>{facility.name}</h3>
            <p>{facility.description}</p>
            <div style={{
              display: 'flex',
              gap: '0.5rem',
              flexWrap: 'wrap',
              justifyContent: 'center',
              marginTop: '1rem'
            }}>
              {facility.features.map((feature, index) => (
                <span
                  key={index}
                  style={{
                    background: '#f7b801',
                    color: '#333',
                    padding: '0.3rem 0.8rem',
                    borderRadius: '20px',
                    fontSize: '0.8rem',
                    fontWeight: '600'
                  }}
                >
                  {feature}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>

      <h3 style={{ textAlign: 'center', marginTop: '3rem', marginBottom: '2rem', color: '#004e89' }}>
        General Amenities
      </h3>
      <div className="facility-grid">
        {amenities.map((amenity, index) => (
          <div key={index} className="facility-card" style={{ backgroundColor: '#f0f8ff' }}>
            <div className="facility-icon" style={{ color: '#ff6b35' }}>
              {amenity.icon}
            </div>
            <h3>{amenity.name}</h3>
          </div>
        ))}
      </div>
    </section>
  );
}
